import { AlertTriangle, Sparkle } from "lucide-react";

/**
 * WO9 A4 — what the approver sees. A quiet line for what we silently cleaned, flagged phrases with
 * a suggestion (never auto-rewritten), and a hard red banner when a fact moved.
 * Deliberately no score and no "AI detection" reading: this is housekeeping, not a detector.
 */
export function HygieneNote({ info, factsChanged, testId = "hygiene" }) {
  const changes = info?.summary;
  const flags = info?.flags || [];
  const problems = factsChanged || [];
  if (!changes && !flags.length && !problems.length) return null;

  return (
    <div className="space-y-1.5" data-testid={`${testId}-note`}>
      {!!problems.length && (
        <div className="rounded-md border border-red-500/40 bg-red-500/10 px-2.5 py-2 text-xs text-red-600 dark:text-red-400"
          data-testid={`${testId}-facts-banner`}>
          <p className="flex items-center gap-1.5 font-semibold">
            <AlertTriangle className="h-3.5 w-3.5" /> A fact changed. Check before posting
          </p>
          <ul className="mt-1 space-y-0.5">
            {problems.map((p, i) => (
              <li key={i} data-testid={`${testId}-fact-${i}`}>
                {p.type === "missing" ? "Dropped" : "Not on file"}: <code>{p.token}</code> — {p.detail}
              </li>
            ))}
          </ul>
          <p className="mt-1">Edit it or draft it again, then post.</p>
        </div>
      )}
      {!!changes && (
        <p className="text-xs text-muted-foreground" data-testid={`${testId}-changes`}>{changes}</p>
      )}
      {!!flags.length && (
        <div className="flex flex-wrap gap-1.5" data-testid={`${testId}-flags`}>
          {flags.map((f, i) => (
            <span key={i} title={f.suggestion}
              className="inline-flex items-center gap-1 rounded-full border border-amber-500/30 bg-amber-500/10 px-2 py-0.5 text-xs text-amber-700 dark:text-amber-400"
              data-testid={`${testId}-flag-${i}`}>
              <Sparkle className="h-3 w-3" />
              {f.type === "repetition" ? `opens like the last two: "${f.phrase}"` : `"${f.phrase}"`}
              <span className="opacity-70">· {f.suggestion}</span>
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
